if (!customElements.get('diggn-oil-review-gallery')) {
  customElements.define('diggn-oil-review-gallery', class DiggnOilReviewGallery extends HTMLElement {
    connectedCallback() {
      if (this.frameButtons) return;

      this.frameButtons = [...this.querySelectorAll('[data-oil-frame]')];
      this.heroTemplates = new Map(
        [...this.querySelectorAll('template[data-oil-hero]')].map((template) => [template.dataset.oilHero, template])
      );
      this.hero = this.querySelector('[data-oil-hero-image]');
      this.heroThumb = this.frameButtons[0].querySelector('img');
      this.heroZoom = this.querySelector('[data-oil-hero-zoom]');
      this.heroScent = this.querySelector('[data-oil-hero-scent]');
      this.heroFrame = this.querySelector('[data-oil-opening]');
      this.stageImage = this.querySelector('[data-oil-artwork]');
      this.panelStage = this.querySelector('[data-oil-panel-stage]');
      this.rail = this.querySelector('[data-oil-rail]');
      this.previous = this.querySelector('[data-oil-previous]');
      this.next = this.querySelector('[data-oil-next]');
      this.index = 1;

      this.frameButtons.forEach((button, index) => {
        button.addEventListener('click', () => this.selectFrame(index + 1));
      });
      this.previous.addEventListener('click', () => this.selectFrame(this.index - 1));
      this.next.addEventListener('click', () => this.selectFrame(this.index + 1));
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const move = event.key === 'ArrowRight' ? 1 : -1;
        this.selectFrame(this.index + (this.dir === 'rtl' ? -move : move));
        if (event.target.matches('[data-oil-frame]')) this.frameButtons[this.index - 1].focus({ preventScroll: true });
      });

      const viewer = this.querySelector('[data-oil-viewer]');
      viewer.addEventListener('touchstart', (event) => {
        if (event.touches.length !== 1) {
          this.swipeStart = null;
          return;
        }
        const point = event.touches[0];
        this.swipeStart = { x: point.clientX, y: point.clientY };
      }, { passive: true });
      viewer.addEventListener('touchend', (event) => {
        if (!this.swipeStart) return;
        const point = event.changedTouches[0];
        const x = point.clientX - this.swipeStart.x;
        const y = point.clientY - this.swipeStart.y;
        this.swipeStart = null;
        if (Math.abs(x) < 45 || Math.abs(x) <= Math.abs(y)) return;
        if (event.cancelable) event.preventDefault();
        const move = x < 0 ? 1 : -1;
        this.selectFrame(this.index + (this.dir === 'rtl' ? -move : move));
      });
      viewer.addEventListener('touchcancel', () => { this.swipeStart = null; }, { passive: true });
    }

    disconnectedCallback() {
      this.reviewObserver?.disconnect();
    }

    // The storefront variant picker calls this with the selected Shopify media ID.
    setActiveMedia(mediaId) {
      const template = this.heroTemplates.get(mediaId);
      if (!template) return;

      this.hero.replaceChildren(template.content.cloneNode(true));
      this.heroThumb.src = template.dataset.thumbnail;
      if (this.heroScent && template.dataset.scent) this.heroScent.textContent = template.dataset.scent;
      if (this.heroZoom) this.heroZoom.dataset.mediaId = template.dataset.modalMedia;
      this.selectFrame(1);
    }

    syncReviewPanel() {
      const panelScore = this.panelStage.querySelector('[data-oil-panel-score]');
      if (!panelScore) return;

      const reviews = document.getElementById('diggn-product-reviews');
      const score = reviews?.querySelector('[data-diggn-score]');
      const count = reviews?.querySelector('[data-diggn-score-count]');
      if (!score || !count) return;

      const update = () => {
        if (Number(score.textContent) <= 0 || !count.textContent.trim()) return;
        panelScore.textContent = score.textContent.trim();
        panelScore.parentElement.hidden = false;
        const panelCount = this.panelStage.querySelector('[data-oil-panel-count]');
        panelCount.textContent = count.textContent.trim();
        panelCount.hidden = false;
      };
      update();
      this.reviewObserver = new MutationObserver(update);
      this.reviewObserver.observe(score, { childList: true, characterData: true, subtree: true });
      this.reviewObserver.observe(count, { childList: true, characterData: true, subtree: true });
    }

    selectFrame(index) {
      if (index < 1 || index > this.frameButtons.length) return;

      this.index = index;
      const selected = this.frameButtons[index - 1];
      const opening = index === 1;
      const panel = selected.dataset.panel && this.querySelector(`template[data-oil-panel="${selected.dataset.panel}"]`);
      if (!opening && !panel) {
        this.stageImage.src = selected.dataset.full || selected.querySelector('img').getAttribute('src');
        this.stageImage.alt = selected.dataset.caption;
      }
      if (this.panelStage) {
        this.reviewObserver?.disconnect();
        this.panelStage.hidden = !panel;
        this.panelStage.replaceChildren(...(panel ? [panel.content.cloneNode(true)] : []));
        this.syncReviewPanel();
      }
      this.heroFrame.hidden = !opening;
      this.stageImage.hidden = opening || Boolean(panel);
      this.frameButtons.forEach((button) => button.removeAttribute('aria-current'));
      selected.setAttribute('aria-current', 'true');
      this.previous.setAttribute('aria-disabled', opening);
      this.next.setAttribute('aria-disabled', index === this.frameButtons.length);
      const item = selected.getBoundingClientRect();
      const rail = this.rail.getBoundingClientRect();
      const left = item.left < rail.left ? item.left - rail.left : Math.max(0, item.right - rail.right);
      const top = item.top < rail.top ? item.top - rail.top : Math.max(0, item.bottom - rail.bottom);
      if (left || top) this.rail.scrollBy({ left, top });
    }
  });
}
